module.exports = __webpack_public_path__ + "static/evergreen-table-sorting-menu-1cbcd178658af3701adbc8b6cf14347a.png";